import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Dialog, Button, Image } from "hesus-ui-kit";
import { initMapDraw } from "@utils/map-draw";
import closeIcon from "@icons/ic-close-white.svg";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  MapContainer,
  ContentDiv,
  FlexRow,
  SectionContainer,
  OuterWrapper,
  EditorDescription,
  EditorDescriptionWrapper,
  EditorDescriptionTitle,
} from "./ViewZone.styled";

const ViewZone = (props) => {
  const { t, data, closeZonePopUp, centerProductStatus, editPrice } = props;

  useEffect(() => {
    if (data.coordinates.length > 0) {
      initMapDraw(
        data.coordinates[0][0][0],
        data.coordinates[0][0][1],
        data.coordinates
      );
    }
  }, []);

  return (
    <>
      <Dialog>
        <div>
          <HeaderWrapper>
            <Title>{t("CATCHMENT_AREA_ZONE")}</Title>
            <Button
              onClick={closeZonePopUp}
              styles={{
                backgroundColor: "transparent",
                border: "none",
                height: "auto",
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Image
                styles={{ width: "auto" }}
                src={closeIcon}
                alt="close Analytical Note price popup"
              />
            </Button>
          </HeaderWrapper>
          <ContentDiv>
            <FlexRow>
              <SectionContainer>
                <OuterWrapper>
                  {data?.coordinates.length > 0 && <MapContainer id="map" />}
                  {data?.coordinates.length === 0 && (
                    <EditorDescriptionTitle>
                      {t("NO_ZONE_FOUND")}
                    </EditorDescriptionTitle>
                  )}
                </OuterWrapper>
              </SectionContainer>
            </FlexRow>
            {data.catchmentTechnicalInfo !== null && (
              <>
                <EditorDescriptionWrapper>
                  <EditorDescriptionTitle>
                    {t("CATCHMENT_AREA_TECH_INFO")}
                  </EditorDescriptionTitle>
                </EditorDescriptionWrapper>
                <EditorDescriptionWrapper>
                  <EditorDescription>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.catchmentTechnicalInfo,
                      }}
                    ></div>
                  </EditorDescription>
                </EditorDescriptionWrapper>
              </>
            )}
          </ContentDiv>

          <ButtonWrapper>
            {!!data.isActive && !!centerProductStatus && (
              <Button
                styles={{
                  color: "white",
                  background: "#1BACE4",
                  border: "1px solid #1BACE4",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#1589b6",
                  },
                }}
                onClick={() => editPrice()}
              >
                {t("EDIT")}
              </Button>
            )}
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                border: "1px solid #ccc",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={closeZonePopUp}
            >
              {t("CLOSE")}
            </Button>
          </ButtonWrapper>
        </div>
      </Dialog>
    </>
  );
};

ViewZone.propTypes = {
  t: PropTypes.func.isRequired,
  coordinates: PropTypes.array,
};

ViewZone.defaultProps = {
  coordinates: [],
};

export default withTranslation()(ViewZone);
